import React, { useState } from 'react'
import { supabase } from '../supabaseClient'

export default function Login() {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    setLoading(true)
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { shouldCreateUser: false },
    })
    if (error) setError(error.message)
    else setSent(true)
    setLoading(false)
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo">
          <div className="logo-mark">QT</div>
          <div className="logo-text">
            <span className="logo-name">Quantum</span>
            <span className="logo-sub">Technologies</span>
          </div>
        </div>
        {sent ? (
          <>
            <h1 className="login-title">Check your email</h1>
            <p className="login-hint">We sent a sign-in link to <strong>{email}</strong>. Click it to access the dashboard.</p>
          </>
        ) : (
          <>
            <h1 className="login-title">Sign in to your account</h1>
            <form onSubmit={handleSubmit} className="login-form">
              <div className="login-field">
                <label className="login-label">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  autoFocus
                />
              </div>
              {error && <p className="login-error">{error}</p>}
              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? 'Sending…' : 'Send magic link'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  )
}
